export default {
  'billingSubscription.title': 'Suscripciones',
  'billingSubscription.description': 'Gestiona suscripciones comerciales de clientes.',

  'billingSubscription.columns.billingLegalName': 'Razón social',
  'billingSubscription.columns.plan': 'Plan',
  'billingSubscription.columns.billingMode': 'Modo de billing',
  'billingSubscription.columns.monthlyFee': 'Tarifa mensual',
  'billingSubscription.columns.currency': 'Moneda',
  'billingSubscription.columns.billingCycleType': 'Ciclo de facturación',
  'billingSubscription.columns.billingCycleCount': 'Cantidad de ciclos',
  'billingSubscription.columns.paymentCollectionMode': 'Modo de cobro',
  'billingSubscription.columns.nextBillingDate': 'Próxima facturación',
  'billingSubscription.columns.autoRenew': 'Renovación automática',

  'billingSubscription.fields.automyPlan': 'Plan Automy',
  'billingSubscription.fields.customerChannelAssignment': 'Asignación de cliente',
  'billingSubscription.fields.defaultPaymentMethod': 'Método de pago predeterminado',
  'billingSubscription.fields.paymentTermsDays': 'Días de plazo de pago',
  'billingSubscription.fields.currentPeriodStart': 'Inicio del período actual',
  'billingSubscription.fields.currentPeriodEnd': 'Fin del período actual',
  'billingSubscription.fields.billingLegalName': 'Razón social',
  'billingSubscription.fields.billingTaxId': 'Identificación fiscal',
  'billingSubscription.fields.billingEmail': 'Email de facturación',
  'billingSubscription.fields.billingCountry': 'País de facturación',
  'billingSubscription.fields.billingAddressLine1': 'Dirección línea 1',
  'billingSubscription.fields.billingAddressLine2': 'Dirección línea 2',
  'billingSubscription.fields.billingCity': 'Ciudad',
  'billingSubscription.fields.billingState': 'Estado / Provincia',
  'billingSubscription.fields.billingPostalCode': 'Código postal',
  'billingSubscription.fields.stripeCustomerId': 'Stripe customer ID',
  'billingSubscription.fields.stripeSubscriptionId': 'Stripe subscription ID',
  'billingSubscription.fields.stripePriceId': 'Stripe price ID',

  'billingPaymentMethodType.card': 'Tarjeta',
  'billingPaymentMethodType.bankAccount': 'Cuenta bancaria',
  'billingPaymentMethodType.invoice': 'Factura',

  'billingSubscriptionStatus.pendingActivation': 'Pendiente de activación',
  'billingSubscriptionStatus.pendingPayment': 'Pendiente de pago',
  'billingSubscriptionStatus.active': 'Activa',
  'billingSubscriptionStatus.pastDue': 'Vencida',
  'billingSubscriptionStatus.canceled': 'Cancelada',
  'billingSubscriptionStatus.suspended': 'Suspendida',

  'billingCycleType.monthly': 'Mensual',
  'billingCycleType.quarterly': 'Trimestral',
  'billingCycleType.annual': 'Anual',

  'billingCollectionMode.automatic': 'Automático',
  'billingCollectionMode.manual': 'Manual',
};
